var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-navbar-nav",
    { staticClass: "sidebar" },
    [
      _c(
        "b-navbar-brand",
        {
          staticClass: "logo",
          attrs: { id: "popover-brand", "b-link": "", to: "/" },
        },
        [
          _c("img", {
            attrs: {
              src: require("../../../content/images/rizoma_black.svg"),
              alt: "rizoma",
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "navbar-version" }, [
            _vm._v(_vm._s(_vm.version)),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sidebar_header mb-3 mt-3" },
        [
          _c("b-link", { attrs: { to: "/", exact: "" } }, [
            _vm._v("PERSONA MORAL"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasMoreThanOneAuthority() && _vm.authenticated
        ? _c(
            "div",
            [
              _c(
                "b-nav-item",
                {
                  staticClass: "pointer",
                  attrs: {
                    id: "consulta-menu-admin",
                    to: { name: "SeleccionaRol" },
                    "data-cy": "entity",
                  },
                },
                [
                  _c("span", { staticClass: "icon-admin-solicitud" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "item-text" }, [
                    _vm._v("Selecciona Rol"),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.authenticated &&
      _vm.hasRolSelected &&
      _vm.selectedRole === "ROLE_EXTERNAL_USER"
        ? _c(
            "div",
            [
              _c(
                "b-nav-item",
                {
                  staticClass: "pointer",
                  attrs: {
                    id: "consulta-menu",
                    to: { name: "ConsultaSolicitudes" },
                    "data-cy": "entity",
                  },
                },
                [
                  _c("span", { staticClass: "icon-admin-solicitud" }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "item-text",
                    domProps: {
                      textContent: _vm._s(_vm.$t("global.menu.consulta-sedes")),
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-nav-item",
                {
                  staticClass: "pointer",
                  attrs: {
                    id: "consulta-menu",
                    to: { name: "ConsultaSubsedes" },
                    "data-cy": "entity",
                  },
                },
                [
                  _c("span", { staticClass: "icon-admin-solicitud" }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "item-text",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.consulta-subsedes")
                      ),
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-nav-item",
                {
                  attrs: {
                    id: "nueva-menu",
                    to: { name: "NuevaSolicitud" },
                    "data-cy": "entity",
                  },
                },
                [
                  _c("span", { staticClass: "icon-solicitud" }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "item-text",
                    domProps: {
                      textContent: _vm._s(_vm.$t("global.menu.nuevo-registro")),
                    },
                  }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.authenticated &&
      _vm.hasRolSelected &&
      _vm.selectedRole === "ROLE_OPERATIVO_RENIECYT"
        ? _c(
            "div",
            [
              _c(
                "b-nav-item",
                {
                  staticClass: "pointer",
                  attrs: {
                    id: "consulta-menu",
                    to: { name: "ConsultaRegistros" },
                    "data-cy": "entity",
                  },
                },
                [
                  _c("span", { staticClass: "icon-admin-solicitud" }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "item-text",
                    domProps: {
                      textContent: _vm._s(_vm.$t("global.menu.consulta-sedes")),
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-nav-item",
                {
                  staticClass: "pointer",
                  attrs: {
                    id: "consulta-menu",
                    to: { name: "ConsultaSubsedesRev" },
                    "data-cy": "entity",
                  },
                },
                [
                  _c("span", { staticClass: "icon-admin-solicitud" }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "item-text",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.consulta-subsedes")
                      ),
                    },
                  }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.authenticated &&
      _vm.hasRolSelected &&
      _vm.selectedRole === "ROLE_DIRECCION_RENIECYT"
        ? _c(
            "div",
            [
              _c(
                "b-nav-item",
                {
                  staticClass: "pointer",
                  attrs: {
                    id: "consulta-menu",
                    to: { name: "ConsultaRegistrosAdmin" },
                    "data-cy": "entity",
                  },
                },
                [
                  _c("span", { staticClass: "icon-admin-solicitud" }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "item-text",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.consulta-registros")
                      ),
                    },
                  }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.authenticated &&
      _vm.hasRolSelected &&
      _vm.selectedRole === "ROLE_OPERATIVO_RENIECYT"
        ? _c(
            "div",
            [
              _c(
                "b-nav-item",
                {
                  staticClass: "pointer",
                  attrs: {
                    id: "consulta-menu",
                    to: { name: "Reportes" },
                    "data-cy": "entity",
                  },
                },
                [
                  _c("span", { staticClass: "icon-solicitud" }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "item-text",
                    domProps: {
                      textContent: _vm._s(_vm.$t("global.menu.reportes")),
                    },
                  }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.authenticated &&
      _vm.hasRolSelected &&
      _vm.selectedRole === "ROLE_DIRECCION_RENIECYT"
        ? _c(
            "div",
            [
              _c(
                "b-nav-item",
                {
                  staticClass: "pointer",
                  attrs: {
                    id: "consulta-menu",
                    to: { name: "Reportes" },
                    "data-cy": "entity",
                  },
                },
                [
                  _c("span", { staticClass: "icon-solicitud" }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "item-text",
                    domProps: {
                      textContent: _vm._s(_vm.$t("global.menu.reportes")),
                    },
                  }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.authenticated &&
      _vm.hasRolSelected &&
      _vm.selectedRole === "ROLE_OPERATIVO_CONSULTA_RENIECYT"
        ? _c(
            "div",
            [
              _c(
                "b-nav-item",
                {
                  staticClass: "pointer",
                  attrs: {
                    id: "consulta-menu",
                    to: { name: "ConsultaRegistrosOperativo" },
                    "data-cy": "entity",
                  },
                },
                [
                  _c("span", { staticClass: "icon-admin-solicitud" }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "item-text",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.consulta-registros")
                      ),
                    },
                  }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.authenticated &&
      _vm.hasRolSelected &&
      _vm.selectedRole === "ROLE_REGISTRO_ANOTACIONES"
        ? _c(
            "div",
            [
              _c(
                "b-nav-item",
                {
                  staticClass: "pointer",
                  attrs: {
                    id: "registro-anotaciones-incumplimiento-menu",
                    to: { name: "RegistrosIncumplimientos" },
                    "data-cy": "entity",
                  },
                },
                [
                  _c("span", { staticClass: "icon-solicitud" }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "item-text",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "global.menu.registro-anotaciones-incumplimiento"
                        )
                      ),
                    },
                  }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority("ROLE_ADMIN") && _vm.authenticated
        ? _c(
            "div",
            [
              _c(
                "b-nav-item",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle:collapseAdmin",
                      arg: "collapseAdmin",
                    },
                  ],
                  staticClass: "pointer",
                  class: { "router-link-active": _vm.subIsActive("/admin") },
                  attrs: {
                    id: "admin-menu",
                    "active-class": "active",
                    "data-cy": "adminMenu",
                  },
                },
                [
                  _c("b-icon", { attrs: { icon: "nut" } }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "item-text",
                    domProps: {
                      textContent: _vm._s(_vm.$t("global.menu.admin.main")),
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "ml-auto when-items" }, [
                    _c(
                      "span",
                      { staticClass: "when-open" },
                      [
                        _c("b-icon", {
                          attrs: { icon: "chevron-down", "font-scale": "1.5" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "when-closed" },
                      [
                        _c("b-icon", {
                          attrs: { icon: "chevron-up", "font-scale": "1.5" },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-collapse", { attrs: { id: "collapseAdmin" } }, [
                _c(
                  "ul",
                  { staticClass: "list-unstyled subitems" },
                  [_c("admin-menu")],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "b-popover",
                {
                  attrs: {
                    disabled: _vm.popOverDisabled,
                    target: "admin-menu",
                    triggers: "hover",
                    placement: "right",
                    boundaryPadding: "50",
                    boundary: "window",
                  },
                  on: {
                    "update:disabled": function ($event) {
                      _vm.popOverDisabled = $event
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.admin.main")
                                ),
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1954790522
                  ),
                },
                [
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "list-unstyled subitems subitemsPopover" },
                    [_c("admin-menu")],
                    1
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }